// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Events_mainWrapper__SIOQe"};